import { AxiosClient } from "redux/AxiosClient";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const addWallOfFameAsync = createAsyncThunk(
  "admin/addWallOfFame",
  async (payload, toolkit) => {
    return await AxiosClient("POST", `/addWallOfFame`, payload, toolkit);
  }
);

export const getAllWallOfFameAsync = createAsyncThunk(
  "admin/getAllWallOfFame",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getAllWallOfFame?page=${payload.page || ""}&limit=${
        payload.limit || ""
      }&search=${payload.search || ""}`,
      [],
      toolkit
    );
  }
);

export const getWallOfFameByIdAsync = createAsyncThunk(
  "admin/getWallOfFameById",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getWallOfFameById/${payload}`,
      [],
      toolkit
    );
  }
);

export const updateWallOfByIdAsync = createAsyncThunk(
  "admin/updateWallOfById",
  async (payload, toolkit) => {
    return await AxiosClient("PUT", `/updateWallOfById`, payload, toolkit);
  }
);

export const deleteWallOfFameAsync = createAsyncThunk(
  "admin/deleteWallOfFame",
  async (payload, toolkit) => {
    return await AxiosClient(
      "DELETE",
      `/deleteWallOfFame/${payload}`,
      [],
      toolkit
    );
  }
);

export const uploadWallOfFameExcelAsync = createAsyncThunk(
  "admin/uploadWallOfFameExcel",
  async (payload, toolkit) => {
    return await AxiosClient(
      "POST",
      `/uploadWallOfFameExcel`,
      payload,
      toolkit
    );
  }
);

export const getAllBulkFilesWallOfFame = createAsyncThunk(
  "admin/getAllBulkFilesWallOfFame",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getAllBulkFiles?page=${payload.page}&limit=${payload.limit}&fileType=${payload?.fileType}`,
      [],
      toolkit
    );
  }
);
